import React from "react";
import Layout from "../components/Layout";
import Seo from "../components/Seo";
import PageHero from "../components/PageHero";
import { Link } from "react-router-dom";
import CtaBand from "../components/CtaBand";
import { services } from "../content/services";

const Services = () => (
  <Layout>
    <Seo
      title="Hizmetlerimiz"
      description="LPG montaj, LPG tank değişimi, LPG bakım ve arıza, sızdırmazlık raporu, genel kontrol, yedek parça, motor yağı değişimi ve çeki demiri montajı. Yalova Altınova Kaytazdere."
      path="/hizmetler"
    />
    <PageHero
      title="Hizmetlerimiz"
      text="LPG işleri 30 yıldır asıl işimiz. Yeni yerimizde motor yağı değişimi ve çeki demiri montajı da yapıyoruz."
      crumbs={[{ label: "Hizmetler" }]}
    />
    <section className="section">
      <div className="container">
        <ul className="service-list">
          {services.map((s) => (
            <li key={s.slug}>
              <Link to={`/hizmetler/${s.slug}`}>
                <h3>
                  {s.title}
                  {s.isNew && <span className="badge badge--new">yeni</span>}
                </h3>
                <p>{s.short}</p>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
    <CtaBand />
  </Layout>
);

export default Services;
